import { render } from "./SaveJobCategory.vue?vue&type=template&id=30549945"
import script from "./SaveJobCategory.vue?vue&type=script&lang=js"
export * from "./SaveJobCategory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__